import { useState } from "react";
import { createContext } from "react";
import { useDispatch } from "react-redux";

import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "../../../redux/actions/loadingActions/loadingActions";
import {
  createFAQAdminService,
  deleteFAQAdminService,
  editFAQAdminService,
  getFAQsAdminService,
} from "./../../../services/adminServices";
import {
  toastErrorMessage,
  toastSuccessMessage,
} from "../../../utils/toastMessage/toastMessage";
import { setMetaAction } from "../../../redux/actions/metaActions/metaActions";

export const faqAdminContext = createContext({
  faqs: [],
  setFAQs: () => {},
  faq: {},
  setFAQ: () => {},
  filter: "",
  setFilter: () => {},
  sort: "",
  setSort: () => {},
  start: "",
  setStart: () => {},
  end: "",
  setEnd: () => {},
  pageCount: null,
  setPageCount: () => {},
  pageNumber: null,
  setPageNumber: () => {},
  itemsCount: null,
  setItemsCount: () => {},
  isShowModal: null,
  setIsShowModal: () => {},
  handleShowModal: () => {},
  handleHideModal: () => {},
  handleGetFAQs: () => {},
  handleCreateFAQ: () => {},
  handleEditFAQ: () => {},
  handleDeleteFAQ: () => {},
});

const FAQAdminContext = ({ children }) => {
  const dispatch = useDispatch();

  const [faqs, setFAQs] = useState([]);
  const [faq, setFAQ] = useState({});
  const [filter, setFilter] = useState("");
  const [sort, setSort] = useState("");
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [pageCount, setPageCount] = useState(1);
  const [pageNumber, setPageNumber] = useState(1);
  const [itemsCount, setItemsCount] = useState(100);
  const [isShowModal, setIsShowModal] = useState(false);

  // Modal Operation
  const handleShowModal = (val, setValue) => {
    setIsShowModal(true);

    if (val) {
      setFAQ(val);
      setValue("title", val.title);
      setValue("questions", val.questions);
    }
  };
  const handleHideModal = () => {
    setIsShowModal(false);
    setFAQ({});
  };

  // Get FAQs
  const handleGetFAQs = async (event) => {
    event?.preventDefault();

    const objData = {
      ...(start && { start }),
      ...(end && { end }),
      filter,
      pageNumber,
      sort,
      itemsCount,
    };
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getFAQsAdminService(objData);
      if (status === 200) {
        setFAQs(data.result?.faqs);
        setPageCount(data?.result?.allPagesCount);
        dispatch(setMetaAction());
      }
    } catch ({ response }) {
      
      if (response && response.status)
        toastErrorMessage(response.data.resultMessage);
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Create FAQ
  const handleCreateFAQ = async (faqData) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await createFAQAdminService(faqData);
      if (status === 200) {
        toastSuccessMessage(data.resultMessage);
        handleGetFAQs();
        handleHideModal();
      }
    } catch ({ response }) {
      
      if (response && response.status)
        toastErrorMessage(response.data.resultMessage);
      dispatch(setLoadingFalseAction());
    }
  };

  // Edit FAQ
  const handleEditFAQ = async (faqData) => {
    const objData = {
      id: faq._id,
      ...faqData,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await editFAQAdminService(objData);
      if (status === 200) {
        toastSuccessMessage(data.resultMessage);
        handleGetFAQs();
        handleHideModal();
      }
    } catch ({ response }) {
      
      if (response && response.status)
        toastErrorMessage(response.data.resultMessage);
      dispatch(setLoadingFalseAction());
    }
  };

  // Delete FAQ
  const handleDeleteFAQ = async (id) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await deleteFAQAdminService(id);
      if (status === 200) {
        toastSuccessMessage(data.resultMessage);
        handleGetFAQs();
      }
    } catch ({ response }) {
      
      if (response && response.status)
        toastErrorMessage(response.data.resultMessage);
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <faqAdminContext.Provider
      value={{
        faqs,
        setFAQs,
        faq,
        setFAQ,
        filter,
        setFilter,
        sort,
        setSort,
        start,
        setStart,
        end,
        setEnd,
        pageCount,
        setPageCount,
        pageNumber,
        setPageNumber,
        itemsCount,
        setItemsCount,
        isShowModal,
        setIsShowModal,
        handleShowModal,
        handleHideModal,
        handleGetFAQs,
        handleCreateFAQ,
        handleEditFAQ,
        handleDeleteFAQ,
      }}
    >
      {children}
    </faqAdminContext.Provider>
  );
};

export default FAQAdminContext;
